import { render } from "./MainUserDetails.vue?vue&type=template&id=6c041d01&scoped=true"
import script from "./MainUserDetails.vue?vue&type=script&lang=js"
export * from "./MainUserDetails.vue?vue&type=script&lang=js"

import "./MainUserDetails.vue?vue&type=style&index=0&id=6c041d01&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c041d01"]])

export default __exports__